import { schema } from 'normalizr';

export const addressSchema = new schema.Entity('addresses');
export const addressesListSchema = new schema.Array(addressSchema);
